'use strict';

var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertCurrency = exports.countryToCurrency = exports.languageToCurrency = void 0;
var signup_1 = require("@gig/magic-sdk/dist/adapter/users/signup");
var getCountries_1 = require("@gig/magic-sdk/dist/adapter/users/getCountries");
var language_1 = require("@gig/magic-sdk/dist/adapter/users/language");
var config_1 = require("../../config");
var LANGUAGE_TO_CURRENCY = (_a = {},
    _a[language_1.Language.BRITISH] = signup_1.Currency.GBP,
    _a[language_1.Language.SWEDISH] = signup_1.Currency.SEK,
    _a[language_1.Language.FINNISH] = signup_1.Currency.EUR,
    _a[language_1.Language.GERMAN] = signup_1.Currency.EUR,
    _a[language_1.Language.NEW_ZEALAND] = signup_1.Currency.NZD,
    _a[language_1.Language.NORWEGIAN] = signup_1.Currency.NOK,
    _a[language_1.Language.TURKISH] = signup_1.Currency.EUR,
    _a[language_1.Language.ENGLISH] = signup_1.Currency.EUR,
    _a[language_1.Language.CANADIAN] = signup_1.Currency.CAD,
    _a[language_1.Language.AUSTRALIAN] = signup_1.Currency.AUD,
    _a[language_1.Language.DUTCH] = signup_1.Currency.EUR,
    _a[language_1.Language.DANISH] = signup_1.Currency.DKK,
    _a[language_1.Language.RUSSIAN] = signup_1.Currency.EUR,
    _a[language_1.Language.LATVIAN] = signup_1.Currency.EUR,
    _a[language_1.Language.SPANISH] = signup_1.Currency.EUR,
    _a[language_1.Language.MACEDONIAN] = signup_1.Currency.MKD,
    _a[language_1.Language.HUNGARIAN] = signup_1.Currency.HUF,
    _a[language_1.Language.CANADIAN_FRENCH] = signup_1.Currency.CAD,
    _a[language_1.Language.JAPANESE] = signup_1.Currency.JPY,
    _a[language_1.Language.HINDI] = signup_1.Currency.INR,
    _a[language_1.Language.THAI] = signup_1.Currency.THB,
    _a[language_1.Language.ARGENTINE_SPANISH] = signup_1.Currency.ARS,
    _a[language_1.Language.ROMANIAN] = signup_1.Currency.RON,
    _a[language_1.Language.SOUTH_AFRICAN] = signup_1.Currency.ZAR,
    _a[language_1.Language.CHILEAN] = signup_1.Currency.CLP,
    _a[language_1.Language.MANDARIN] = signup_1.Currency.USD,
    _a[language_1.Language.PERU] = signup_1.Currency.PEN,
    _a[language_1.Language.BRAZILIAN_PORTUGUESE] = signup_1.Currency.BRL,
    _a[language_1.Language.ESTONIAN] = signup_1.Currency.EUR,
    _a[language_1.Language.IRISH] = signup_1.Currency.EUR,
    _a[language_1.Language.AMERICAN_ENGLISH] = signup_1.Currency.USD,
    _a);
/**
 * Gets the currency for the specified language.
 * @param language Market to get the currency for
 * @param defaultCurrency Default currency if none is specified for this language
 */
function languageToCurrency(language, defaultCurrency) {
    if (defaultCurrency === void 0) { defaultCurrency = signup_1.Currency.EUR; }
    return LANGUAGE_TO_CURRENCY[language] || defaultCurrency;
}
exports.languageToCurrency = languageToCurrency;
var COUNTRY_TO_CURRENCY = (_b = {},
    _b[getCountries_1.Country.UNITED_KINGDOM] = signup_1.Currency.GBP,
    _b[getCountries_1.Country.NEW_ZEALAND] = signup_1.Currency.NZD,
    _b[getCountries_1.Country.SWEDEN] = signup_1.Currency.SEK,
    _b[getCountries_1.Country.NORWAY] = signup_1.Currency.NOK,
    _b[getCountries_1.Country.CANADA] = signup_1.Currency.CAD,
    _b[getCountries_1.Country.SOUTH_AFRICA] = signup_1.Currency.ZAR,
    _b[getCountries_1.Country.ARGENTINA] = signup_1.Currency.ARS,
    _b[getCountries_1.Country.ROMANIA] = signup_1.Currency.RON,
    _b[getCountries_1.Country.CHILE] = signup_1.Currency.CLP,
    _b[getCountries_1.Country.PERU] = signup_1.Currency.PEN,
    _b[getCountries_1.Country.BRAZIL] = signup_1.Currency.BRL,
    _b[getCountries_1.Country.PHILIPPINES] = signup_1.Currency.PHP,
    _b);
/**
 * Gets the currency for the specified country.
 * @param country Country to get the currency for
 * @param defaultCurrency dDfault currency if none is specified for this country
 */
function countryToCurrency(country, defaultCurrency) {
    if (defaultCurrency === void 0) { defaultCurrency = signup_1.Currency.EUR; }
    return COUNTRY_TO_CURRENCY[country] || defaultCurrency;
}
exports.countryToCurrency = countryToCurrency;
/**
 * Converts a value in euro to a given currency using
 * multipliers sets in the config
 *
 * If the value is not an integer
 * it will return rounded with not more than 2 decimal
 *
 * e.g. 1.73 * 3 = 5.1899999999999995 // will be 5.19
 *
 *
 * @param value
 * @param currency
 */
function convertCurrency(value, currency) {
    var multiplier = config_1.magicConfig.currencyMultipliers[currency];
    if (!multiplier) {
        throw new Error("Conversion failed, missing " + currency + " multiplier");
    }
    var result = value * multiplier;
    if (Number.isInteger(result)) {
        return result;
    }
    return parseFloat((value * multiplier).toFixed(2));
}
exports.convertCurrency = convertCurrency;
